import type { FC } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';
import { AnalyticsEventSender } from '@alfa-bank/site-analytics-event-sender/analytics-event-sender';

import { selectAppMeta, selectActiveFormStep } from '../../../store';
import type { TDeliveryFinalStepDesktop } from '../model';
import { replaceLabelToPhone } from '../../../helpers/helpers';
import { analyticsDeliveryFinalStepSmev } from '../analytics';

export const DeliveryFinalStepDesktop: FC<TDeliveryFinalStepDesktop> = ({
    Aligner,
    Button,
    Img,
    Link,
    Text,
    button,
    image,
    subtitle,
    title,
}) => {
    const { phone } = useSelector(selectAppMeta);
    const currentFormStep = useSelector(selectActiveFormStep);
    const subtitleWithPhone = replaceLabelToPhone(subtitle, phone);
    const analytics = analyticsDeliveryFinalStepSmev(currentFormStep);

    return (
        <Aligner>
            {image && (
                <Img
                    height={image.height}
                    src={image.src}
                    styler={{ marginBottom: 32 }}
                    width={image.width}
                />
            )}
            <Text styler={{ marginBottom: 16, marginTop: 0 }} tag="h2" view="medium">
                {title}
            </Text>
            <Text styler={{ marginTop: 0, marginBottom: 0 }} view="primary-medium">
                {subtitleWithPhone}
            </Text>
            {button && (
                <Aligner styler={{ marginTop: 24, marginBottom: 0 }}>
                    <AnalyticsEventSender
                        $events={{
                            onClick: {
                                data: analytics?.buttonClick,
                            },
                        }}
                    >
                        <Link border="hidden" href={button.href} target="_blank">
                            <Button size="s" view="primary">
                                {button.text}
                            </Button>
                        </Link>
                    </AnalyticsEventSender>
                </Aligner>
            )}
        </Aligner>
    );
};
